import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ViewToggle, { useViewMode } from "@/components/ViewToggle";
import { Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

const SUPPLEMENT_IMG = "https://static.prod-images.emergentagent.com/jobs/6095044a-36c4-403a-b71f-9edf76c9066f/images/0edbba1415b0aca8b4e2dc4a0fc13bf54475199a6193a86967bc3e7177e9c47b.png";

export default function Portfolio() {
    const [items, setItems] = useState([]);
    const [view, setView] = useViewMode("portfolio", "list");
    const load = () => api.get("/portfolio").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const del = async (id) => {
        if (!window.confirm("¿Eliminar este producto del portfolio?")) return;
        await api.delete(`/portfolio/${id}`);
        toast.success("Producto eliminado");
        load();
    };

    return (
        <div className="fade-up">
            <PageHeader
                eyebrow={`Portfolio · ${items.length} productos`}
                title="Productos propios"
                lead="Fórmulas aprobadas convertidas en producto del catálogo Dr. Daniel Quirós."
            />
            <div className="px-8 md:px-12 py-8 max-w-6xl">
                <div className="flex items-center justify-end mb-4">
                    <ViewToggle value={view} onChange={setView} testid="portfolio-view-toggle"/>
                </div>
                {items.length === 0 ? (
                    <div className="border hairline bg-white p-12 text-center text-[var(--ink-3)]" data-testid="portfolio-empty">
                        Aún no has añadido productos al portfolio. Aprueba una fórmula para empezar.
                    </div>
                ) : view === "list" ? (
                    <div className="surface overflow-x-auto" data-testid="portfolio-list">
                        <table className="data-table w-full">
                            <thead><tr><th>Producto</th><th>Marca</th><th>Indicación</th><th>Composición</th><th></th></tr></thead>
                            <tbody>
                                {items.map((p) => (
                                    <tr key={p.id} data-testid={`portfolio-row-${p.id}`}>
                                        <td className="font-medium">{p.name}</td>
                                        <td className="text-[var(--ink-2)]">{p.brand}</td>
                                        <td className="text-[var(--ink-2)] text-xs">{p.indication}</td>
                                        <td className="mono text-xs text-[var(--ink-2)] max-w-[300px] truncate">{(p.composition || []).map((c) => `${c.name} ${c.dose_mg}mg`).join(" + ")}</td>
                                        <td><button onClick={() => del(p.id)} className="text-[var(--terra-2)] hover:opacity-70" data-testid={`portfolio-delete-${p.id}`}><Trash size={14}/></button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--line)] border hairline" data-testid="portfolio-cards">
                        {items.map((p) => (
                            <article key={p.id} className="bg-white p-5 flex flex-col" data-testid={`portfolio-item-${p.id}`}>
                                <img src={SUPPLEMENT_IMG} alt="" className="w-full h-32 object-cover grayscale mb-4" />
                                <div className="label-eyebrow mb-1">{p.brand}</div>
                                <h3 className="font-display text-lg tracking-tight leading-snug mb-2">{p.name}</h3>
                                <div className="text-xs text-[var(--ink-2)] mono mb-3">
                                    {(p.composition || []).map((c) => `${c.name} ${c.dose_mg}mg`).join(" + ")}
                                </div>
                                <div className="text-xs text-[var(--ink-3)] mb-3">{p.indication}</div>
                                <button
                                    onClick={() => del(p.id)}
                                    className="text-xs text-[var(--ink-3)] hover:text-[var(--terra-2)] inline-flex items-center gap-1 mt-auto self-start"
                                    data-testid={`portfolio-delete-${p.id}`}
                                >
                                    <Trash size={12}/> Eliminar
                                </button>
                            </article>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
